<div class="unauthorized">
  <div class="unauthorized__container">
    <div class="unauthorized__icon"><app-icon name="shield" [size]="28" /></div>
    <h2 class="unauthorized__title">Access Denied</h2>
    <p class="unauthorized__body">
      You do not have permission to view this page.
    </p>
    <div class="unauthorized__actions">
      <button class="btn btn-primary" type="button" (click)="goToServiceProviders()">
        Go to Service Providers
      </button>
      <button class="btn btn-secondary" type="button" [disabled]="loading()" (click)="signOut()">
        Sign Out
      </button>
    </div>
  </div>
</div>
